import { Instance, types } from 'mobx-state-tree';
import { Platform } from '../enums/platform';
import { builds_api_url } from '../../config/build-api-url';
import { formatBytes } from '../../utils';

export const Artefact = types.model(
    'Artefact',
    {
        id: types.identifier,
        buildConfig: '',
        environment: '',
        extension: '',
        platform: '',
        size: 0,
        version: ''
    }).views(self => ({

    readableSize() {
        return formatBytes(self.size, 0);
    }
}))
    .actions(self => ({

        async getDownloadUrl(os: string, projectId: string, buildId: string, token: string): Promise<string> {

            const createDownloadUrl = async () => {
                const response = await fetch(`${builds_api_url}/download?p=${projectId}&b=${buildId}&a=${self.id}&t=${token}`);
                if (!response.ok)
                    throw new Error('Failed to get download url');

                const data = await response.json();
                return data.url;
            };

            if (os === 'all' && self.platform === 'ios')
                return await createDownloadUrl();

            else if (self.platform === Platform.android)
                return await createDownloadUrl();

            else if (self.platform === Platform.ios) {

                const and = '%26';
                const eq = '%3D';
                const qm = '%3F';

                return `itms-services://?action=download-manifest&url=${builds_api_url}/ios/manifest${qm}p${eq}${projectId}${and}b${eq}${buildId}${and}a${eq}${self.id}${and}t${eq}${token}`;
            }
        }
    }));


export interface IArtefact extends Instance<typeof Artefact> {
}
